import { TourAPIStrategy } from '../types/OnboardingTour';
import { PLACEMENT } from '../types/Placement';
import { toArrowPlacement } from '../utils/toArrowPlacement';
export const MARKETING_STUDIO_TOUR_ID = 'marketing-studio-tour';
const MARKETING_STUDIO_TOUR_STEPS = [{
  title: {
    key: 'app.tours.marketing_studio.step.title'
  },
  description: {
    key: 'app.tours.marketing_studio.step.description'
  },
  targetSelector: '[id="marketing-toggle"]',
  placement: PLACEMENT.RIGHT,
  arrowPosition: toArrowPlacement(PLACEMENT.RIGHT_BOTTOM),
  offset: {
    top: 60,
    left: 230
  }
}];
export const MARKETING_STUDIO_TOUR = {
  id: MARKETING_STUDIO_TOUR_ID,
  apiStrategy: TourAPIStrategy.ONBOARDING_TOURS_PORTAL_BASED,
  steps: MARKETING_STUDIO_TOUR_STEPS
};